// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"cc5cd9c5","144":"58e70467","168":"ac7974d6","296":"a6c45f37","391":"b7f5471c","415":"c5e1e6bb","453":"d456ce70","497":"3eda04f0","594":"95ed8aba","707":"1d7e66d6","977":"21ecaadc"}[chunkId] + ".chunk.js";
};